import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

/**
 * Converts a UTC ISO string to a dayjs object in the browser's local timezone.
 * Use when receiving a UTC timestamp from the backend to display to the user.
 * Returns null if input is falsy or invalid.
 */
export const utcToLocal = (utcIsoString) => {
    if (!utcIsoString) return null;
    const str = String(utcIsoString).trim();
    const withZ = /[zZ]|[+-]\d{2}:\d{2}$/.test(str) ? str : `${str}Z`;
    const localDayjs = dayjs.utc(withZ).local();
    return localDayjs.isValid() ? localDayjs : null;
};

/**
 * Converts a local dayjs object (from a date picker) back to a UTC ISO string without trailing 'Z'.
 * Use in onChange/onAccept handlers before storing or sending to the backend.
 * Returns "" if value is falsy or invalid (protects against mid-typing invalid states).
 */
export const localToUtc = (localDayjsValue) => {
    if (!localDayjsValue) return "";
    if (typeof localDayjsValue.isValid === "function" && !localDayjsValue.isValid()) return "";
    return localDayjsValue.utc().toISOString().slice(0, -1);
};

/**
 * Converts a local dayjs object to the API date-time query format in UTC.
 * Example output: 2026-05-19T03:30:00
 */
export const localToUtcDateTimeParam = (localDayjsValue) => {
    if (!localDayjsValue) return "";
    if (typeof localDayjsValue.isValid === "function" && !localDayjsValue.isValid()) return "";
    return localDayjsValue.utc().format("YYYY-MM-DDTHH:mm:ss");
};
